export default "__VITE_ASSET__DYne8ReC__"